export const ProductType = {
  Analytics: 0,
  Careers: 1,
  Crm: 2,
  ClinicalAnalytics: 3,
};
